import db from "@/plugins/dexie"
import moment from "moment-timezone";
import dadosTabelas from "./local/tabelas"
import apirecebimentoweb from '@/services/api-recebimentoweb';
import store from '@/store/index';
import $_enviaPedido from "./local/enviaPedido";
import $_enviaVisita from "./local/enviaVisita";
import $_enviaVenda from "./local/enviaVenda";

export default async function $_atualizaLocal() {
    console.log('=>>> Iniciando Sincronização Otimizada');
    store.dispatch('atualizalocal/updateProcessados', 0);
    store.dispatch('atualizalocal/updateTotal', 0);
    const info = dadosTabelas();
    const cache = store.getters['cache/arraydata'];
    let arrayDataAtualizacao;
    if (!cache.length) {
        arrayDataAtualizacao = await Promise.all(Object.entries(info).map(async ([ nome, dados ]) => {
            if (!db[nome]) {
                console.warn(`Tabela '${nome}' definida em tabelas.js não existe no dexie.js`);
                return { tabela: dados.nomeapi || nome, tabelaApp: nome, data: '1997-01-01 13:00:00' };
            }

            const dataatt = await db[nome].orderBy(dados.campoatt).filter(item => item[dados.campoatt] !== null).last();
            const dataattFinal = dataatt?.[dados.campoatt];
            
            console.log(dados.nomeapi || nome, 'data', dataattFinal || 'Inicial');
            
            return {
                tabela: dados.nomeapi || nome,
                tabelaApp: nome,
                data: !dataattFinal 
                    ? moment.utc('01-01-1997 13:00:00', 'DD-MM-YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
                    : moment.utc(dataattFinal).format('YYYY-MM-DD HH:mm:ss.SSS')
            };
        }));
        store.commit('cache/SET_CACHE_ARRAYDATA', arrayDataAtualizacao);
    } else {
        arrayDataAtualizacao = store.getters['cache/arraydata'];
    }

    if (arrayDataAtualizacao.every(item => item.data === "1997-01-01 13:00:00")) {
        store.dispatch('atualizalocal/primeiroUpdate', true);
        store.dispatch('cache/primeiroUpdate', true);
    }
    const retorno = await apirecebimentoweb.post(`all/itemsaatualizar`, arrayDataAtualizacao);
    store.dispatch('atualizalocal/primeiroUpdate', false);
    console.log('<<<= Dados recebidos da API');
    
    $_geraTotal(retorno.data);

    for (const item of retorno.data) {
        $_geraLog(item);
        if (info[item.tabela]) {
            await $_manipulaTabela(item, info);
        } else {
            console.warn(`Tabela '${item.tabela}' retornada da API não tem definição local.`);
        }
    }
}

async function $_geraLog({ data, tabela }) {
    console.log(`%cTabela: ${tabela} | Itens: ${data.length}`, 'font-weight: bold; color: #5cc');
}

async function $_manipulaTabela({ data, tabela }, info) {
    if (!db[tabela]) return;

    const prefixo = info[tabela].prefixo;
    const campoIdNuvem = `${prefixo}idnuvem`;
    const campoDataAlteracao = info[tabela].campoatt;

    let cloudIds = [];
    let localIds = [];

    try {
        [cloudIds, localIds] = await Promise.all([
            db[tabela].orderBy(campoIdNuvem).keys(),    
            db[tabela].orderBy(campoIdNuvem).primaryKeys()
        ]);
    } catch (e) {
        console.warn(`Índice '${campoIdNuvem}' não encontrado na tabela ${tabela}. Usando toArray (lento).`);
        const all = await db[tabela].toArray();
        cloudIds = all.map(item => item[campoIdNuvem]);
        localIds = all.map(item => item.id);
    }

    const idLocalMap = {};
    const idsNuvemExistentes = []; 

    for (let i = 0; i < cloudIds.length; i++) {
        const cId = cloudIds[i];
        const lId = localIds[i];
        if (cId != null && cId !== 'null') {
            idLocalMap[cId] = lId;
            idsNuvemExistentes.push(cId);
        }
    }
    await $_deletaLocal(idsNuvemExistentes, tabela, info);

    const novosItens = [];
    const modificacoes = [];
    
    const totalItems = data.length;
    let processedItems = 0;
    const progressThreshold = Math.max(50, Math.floor(totalItems * 0.05));

    let possuiUpdates = false;
    let possuiCreates = false;

    data.forEach((item) => {
        const itemFormatado = info[tabela].model(item);
        const idLocal = idLocalMap[item.id];

        if (idLocal !== undefined) {
            if (!possuiUpdates) {
                possuiUpdates = true;
                store.dispatch('atualizalocal/addAAtualizar', 1);
            }
            modificacoes.push({
                key: idLocal, 
                changes: itemFormatado
            });
        } else {
            if (!possuiCreates) {
                possuiCreates = true;
                store.dispatch('atualizalocal/addAAdicionar', 1);
            }
            novosItens.push(itemFormatado);
        }
        
        processedItems++;
        if (processedItems % progressThreshold === 0) {
            store.dispatch('atualizalocal/addProcessados', progressThreshold);
        }
    });

    const restante = processedItems % progressThreshold;
    if (restante > 0) store.dispatch('atualizalocal/addProcessados', restante);

    if (modificacoes.length > 0) {
        try {
            await db[tabela].bulkUpdate(modificacoes);

            const ultimaDataAlteracao = modificacoes
            .map((obj) => obj.changes[campoDataAlteracao])
            .sort((a, b) => new Date(b) - new Date(a))[0];
            
            if (ultimaDataAlteracao) {
                store.dispatch('cache/atualizaData', { 
                    data: moment.utc(ultimaDataAlteracao).format('YYYY-MM-DD HH:mm:ss.SSS'), 
                    tabela 
                });
            }

            store.dispatch('atualizalocal/addEstaAtualizado', tabela);  
            store.dispatch('cache/esvaziarCache', { tabela });           
        } catch (err) {
            console.error(`Erro Bulk Update ${tabela}:`, err);
            store.dispatch('atualizalocal/addEstaAtualizado', { tabela, erro: err.message });
        }
    }
    
    if (novosItens.length > 0) {
        try {
            await db[tabela].bulkAdd(novosItens, { allKeys: true });
            
            if (['produto', 'cliente'].includes(tabela)) {
                // Exemplo: se quiseres atualizar a store do Vuex com os novos dados
                // store.dispatch('cache/pushCache', {tabela, novosItens});
            } 
            
            const primeiroUpdate = store.getters['cache/primeiroUpdate'];
            if (!primeiroUpdate) {              
                const ultimaDataAlteracao = novosItens
                    .map(item => item[campoDataAlteracao])
                    .sort((a, b) => new Date(b) - new Date(a))[0];

                if (ultimaDataAlteracao) {
                    store.dispatch('cache/atualizaData', { 
                        data: moment.utc(ultimaDataAlteracao).format('YYYY-MM-DD HH:mm:ss.SSS'), 
                        tabela 
                    });
                }
            }
            store.dispatch('atualizalocal/addEstaAdicionado', tabela);
        } catch (err) {
            console.error(`Erro Bulk Add ${tabela}:`, err);
            store.dispatch('atualizalocal/addEstaAdicionado', { tabela, erro: err.message });
        }
    }
}

async function $_geraTotal(data) {
    let total = 0
    for (const tabela of data) {
        total += tabela.data.length;
    }
    store.dispatch('atualizalocal/updateTotal', total);
}

async function $_deletaLocal(idNuvemExistentesNoApp, tabela, info) {
    let { data } = await apirecebimentoweb.get(`${tabela}/idnuvem`);
    
    const idsNaNuvemSet = new Set(data.map((item) => item.id));
    
    const deleteIds = idNuvemExistentesNoApp.filter(idnuvem => !idsNaNuvemSet.has(idnuvem));

    if (deleteIds.length > 0) {
        const chunkSize = 500;
        const prefixoIdNuvem = `${info[tabela].prefixo}idnuvem`;

        for (let i = 0; i < deleteIds.length; i += chunkSize) {
            const chunk = deleteIds.slice(i, i + chunkSize);

            await db.transaction('rw', db[tabela], async () => {
                await db[tabela]
                    .where(prefixoIdNuvem)
                    .anyOf(chunk)
                    .delete();
            });
        }
        store.dispatch('cache/esvaziarCache', { tabela, att: info[tabela].campoatt });
    }
}

export async function SetupEnvioLocal({ silent = false } = {}) {
    if (navigator.onLine) {
        await $_atualizaLocal(silent); 
        await $_enviaPedido();
        await $_enviaVisita();
        await $_enviaVenda();
    }
}